<template>
    <module v-model="showPop" :type="1" :subTitle="`我的投票数：${totalVotes}张`">
        <div class="vote-history">
            <div class="vote-table" v-show="voteHistory.length">
                <div class="vote-table-header">
                    <div class="col-book">书籍作品</div>
                    <div class="col-votes">我的投票数</div>
                </div>
                <div class="vote-table-body">
                    <div
                        v-for="(item, index) in voteHistory"
                        :key="index"
                        class="vote-table-row"
                    >
                        <div class="col-book">{{ item.book_info?.title ? `《${item.book_info?.title}》` : '—' }}</div>
                        <div class="col-votes">{{ item.vote_num ?? 0 }}</div>
                    </div>
                    <div ref="loadingRef" v-show="voteHistory.length > 5"><QLoading client="freereader" endTitle="厉害！居然滑到底了！" :status="originVoteHistory.length ? '2' : '3'" title="加载中..."></QLoading></div>
                </div>
            </div>
            <div class="vote-empty-wrapper" v-if="!voteHistory.length">
                <q-empty type="data" tip="暂无投票记录"></q-empty>
            </div>
        </div>
    </module>
</template>
<script lang="ts" setup>
import { computed, onMounted, watch, nextTick } from 'vue';
import module from './card.vue';
import { QEmpty, QLoading } from '@q-front-npm/h5-ui';
import { ref } from 'vue';
import { apiGetVoteHistory, apiGetBookDetail } from '@/http/api';
import { useIntersectionObserver } from '@common/hooks/useIntersectionObserver';
const showPop = ref(false);
const voteHistory = ref([]);
const loading = ref(false);
const loadingRef = ref<InstanceType<typeof QLoading>>();

const totalVotes = ref(0);
const originVoteHistory = ref([]);
const getVoteHistory = async() => {
    totalVotes.value = 0;
    loading.value = true;
    const res = await apiGetVoteHistory({}).finally(() => {
        loading.value = false;
    });
    res.list.forEach(item => {
        totalVotes.value += (+item.vote_num || 0);
    });

    voteHistory.value = res.list.filter(item => !!item.book_info);
    originVoteHistory.value = res.list.filter(item => !item.book_info);
};

let isLoadmore = false;
const onLoadMore = async() => {
    if (isLoadmore) return;
    if (originVoteHistory.value.length === 0) {
        return;
    }
    isLoadmore = true;
    const books = originVoteHistory.value.splice(0, 10);
    const res = await apiGetBookDetail({
        book_ids: books.map((item: any) => item.book_id),
    }).finally(() => {
        isLoadmore = false;
    });
    books.forEach((item: any) => {
        item.book_info = res.book_list.find((book: any) => book.book_id === item.book_id);
    });
    voteHistory.value.push(...books);
};

const { targetRef, isIntersecting, } = useIntersectionObserver({
    threshold: 0.5,
});

const open = () => {
    showPop.value = true;
    voteHistory.value = [];
    originVoteHistory.value = [];

    getVoteHistory();
    nextTick(() => {
        console.log('loadingRef', loadingRef.value);
        targetRef.value = loadingRef.value as HTMLElement;
        watch(isIntersecting, (newVal) => {
            if (newVal) {
                onLoadMore();
            }
        });
    });
};

defineExpose({
    open,
});
</script>
<style lang="scss" scoped>
.vote-history {
    background: #fff;
    border-radius: 16px;
    overflow: hidden;
    padding: 32px 40px;
    max-height: 50vh;
    .vote-empty-wrapper {
        height: 400px;
    }
}

.vote-table {
    width: 100%;
    min-height: 400px;
}

.vote-table-header {
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 32px;
    color: #896B49;
    line-height: 44px;
    margin-bottom: 28px;
}

.vote-table-body {
    width: calc(100% + 12px);
    position: relative;
    left: -12px;
    max-height: calc(50vh - 100px);
    overflow-y: auto;
    // 不展示滚动条
    &::-webkit-scrollbar {
        display: none;
    }
}

.vote-table-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 28px;
    color: #111111;
    line-height: 40px;
    margin-bottom: 28px;

    &:last-child {
        border-bottom: none;
    }
}

.col-book {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.col-votes {
    flex-shrink: 0;
    margin-left: 24px;
    min-width: 80px;
    text-align: right;
}

.vote-empty {
    padding: 48px 20px;
    text-align: center;
    font-size: 26px;
    color: #999;
}
</style>
